export default __webpack_public_path__ + "static/media/nagrody.95f454b5.jpg";